/*
 * 1DS JS SDK QoS plugin, 3.1.9
 * Copyright (c) Microsoft and contributors. All rights reserved.
 * (Microsoft Internal Only)
 */
/**
* OutgoingQosEvent.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2018
*/
import { isValueAssigned } from "@microsoft/1ds-core-js";
import QosEvent from "./QosEvent";
var OutgoingQosEvent = /** @class */function () {
  function OutgoingQosEvent() {
    this._qosEvent = new QosEvent();
  }
  OutgoingQosEvent.prototype._setQosProperties = function (event, eventData) {
    this._qosEvent._setCommonProperties(event, eventData);
    event.baseData["dependencyOperationName"] = eventData.dependencyOperationName;
    event.baseData["dependencyName"] = eventData.dependencyName;
    event.baseData["dependencyType"] = eventData.dependencyType || "WebService"; // WebService is a common schema term for reffering any kind of webservice
    if (isValueAssigned(eventData.dependencyOperationVersion)) {
      event.baseData["dependencyOperationVersion"] = eventData.dependencyOperationVersion;
    }
    if (isValueAssigned(eventData.responseSizeBytes)) {
      event.baseData["responseSizeBytes"] = eventData.responseSizeBytes;
    }
  };
  return OutgoingQosEvent;
}();
export default OutgoingQosEvent;